(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertigo-mesa"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('vertigo-mesa')) return;

  const FLIP_MS = 700;      // vuelta del sobre
  const OPEN_MS = 350;      // apertura de la solapa
  const STAGGER_MS = 110;   // separación entre piezas al salir
  const FLY_MS = 900;       // vuelo de cada pieza
  const DOUBLE_TAP_MS = 300; // margen entre dos clics para contar como doble clic (solo en el sobre)
  const NUDGE_FIRST_MS = 10000; // primera llamada de atención del botón, desde que la página termina de cargar
  const NUDGE_EVERY_MS = 3000;  // pausa entre una llamada de atención y la siguiente
  const NUDGE_ANIM_MS = 1000;   // duración de la vibración (igual que la animación vm-cta-nudge)

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const getVar = (el, name) => parseFloat(el.style.getPropertyValue(name));

  class VertigoMesa extends HTMLElement {
    connectedCallback(){
      this.mat = this.querySelector('.vm-mat');
      this.sobre = this.querySelector('.vm-sobre');
      this.hint = this.querySelector('.vm-hint');
      this.info = this.querySelector('.vm-info');
      this.piezas = [...this.querySelectorAll('.vm-pieza')];
      this.decor = [...this.querySelectorAll('.vm-decor')];
      this.mesaCta = this.querySelector('.vm-mesa-cta');
      this.soon = this.querySelector('.vm-soon');
      this.zTop = 10;
      this.opened = false;
      this.portrait = null;
      this.timers = [];

      // Solo vibra «Suscríbete ya» de la mesa; el botón del menú queda fijo.
      // (Para que vibren los dos a la vez, añadir aquí this.querySelector('.vm-nav__cta').)
      this.nudge([this.querySelector('.vm-mesa-cta')]);

      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(this.mat);

      this.piezas.forEach(el => this.draggable(el, () => this.showInfo(el)));
      this.decor.forEach(el => this.draggable(el, () => this.showInfo(el)));
      this.draggable(this.sobre, () => this.tapSobre(), () => this.opened);

      this.preventa();

      this.info.querySelector('.vm-info__close').addEventListener('click', () => this.hideInfo());
      this.mat.addEventListener('pointerdown', e => { if (e.target === this.mat) this.hideInfo(); });
      this.onKey = e => { if (e.key === 'Escape') this.hideInfo(); };
      document.addEventListener('keydown', this.onKey);

      // En el personalizador de Shopify: al seleccionar un bloque, abre el sobre al instante
      // y muestra esa pieza, para poder ver cómo queda sin hacer clic cada vez.
      if (window.Shopify && window.Shopify.designMode){
        this.onBlockSelect = e => {
          const decor = this.decor.find(p => p === e.target || p.contains(e.target));
          if (decor){
            decor.style.zIndex = ++this.zTop;
            this.showInfo(decor);
            return;
          }
          const el = this.piezas.find(p => p === e.target || p.contains(e.target));
          if (!el) return;
          this.open(true);
          el.style.zIndex = ++this.zTop;
          this.showInfo(el);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback(){
      this.ro && this.ro.disconnect();
      this.timers.forEach(clearTimeout);
      document.removeEventListener('keydown', this.onKey);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    /* Llamada de atención de los botones: 10 s después de cargar la página crecen, vibran
       y vuelven; luego repiten cada 3 s (contando desde que terminan) hasta recargar.
       Un único reloj para todos, así vibran exactamente a la vez. Los botones ocultos
       (p. ej. «Suscríbete ya» antes de abrir el sobre) se saltan ese ciclo. */
    nudge(buttons){
      buttons = buttons.filter(Boolean);
      if (!buttons.length) return;
      const later = (fn, ms) => this.timers.push(setTimeout(fn, ms));
      const run = () => {
        buttons.forEach(b => {
          b.classList.remove('is-nudging');
          if (b.classList.contains('vm-mesa-cta') && !b.classList.contains('is-visible')) return;
          void b.offsetWidth; // reinicia la animación
          b.classList.add('is-nudging');
        });
        later(run, NUDGE_ANIM_MS + NUDGE_EVERY_MS);
      };
      const start = () => later(run, NUDGE_FIRST_MS);
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    }

    /* La unidad --u y la cuadrícula se adaptan al tamaño de la mesa */
    layout(){
      const { width, height } = this.mat.getBoundingClientRect();
      if (!width || !height) return;
      const portrait = height > width;
      const u = (portrait ? Math.min(width * 1.7, height) : Math.min(width, height * 1.6)) / 100;
      const cell = Math.max(16, Math.round(u * 2.6));
      this.style.setProperty('--u', u + 'px');
      this.style.setProperty('--cell', cell + 'px');

      const top = this.querySelector('.vm-mat__ruler--top');
      const left = this.querySelector('.vm-mat__ruler--left');
      let t = '', l = '';
      for (let i = 5; cell * (1 + i) < width - cell; i += 5) t += `<span style="left:${cell * (1 + i)}px;top:${cell / 2}px">${i}</span>`;
      for (let i = 5; cell * (1 + i) < height - cell; i += 5) l += `<span style="top:${cell * (1 + i)}px;left:${cell / 2}px">${i}</span>`;
      top.innerHTML = t;
      left.innerHTML = l;

      // Al cargar y al girar el móvil: los objetos de la mesa (y las piezas, si el sobre
      // está abierto) se colocan en la disposición de ordenador o de móvil según toque.
      // Los objetos que el visitante ya ha movido se quedan donde los dejó.
      if (portrait !== this.portrait){
        const first = this.portrait === null;
        this.portrait = portrait;
        this.decor.forEach(el => { if (!el.dataset.moved) this.place(el); });
        if (!first && this.opened) this.piezas.forEach(el => this.place(el));
      }
      if (this.opened) this.fitSoon();
    }

    /* Aviso «Coming soon»: lo centra en el hueco entre la regla de arriba y el sobre,
       y reduce la letra hasta que la frase quepa en ese hueco, sea larga o corta. */
    fitSoon(){
      const el = this.soon;
      if (!el) return;
      el.style.fontSize = '';
      const m = this.mat.getBoundingClientRect();
      const s = this.sobre.getBoundingClientRect();
      const cell = parseFloat(this.style.getPropertyValue('--cell')) || 16;
      const top = cell * 1.6;
      const room = Math.max(cell * 2, s.top - m.top - cell * 1.6 - top);
      let fs = parseFloat(getComputedStyle(el).fontSize);
      while (el.offsetHeight > room && fs > 14){
        fs *= .92;
        el.style.fontSize = fs + 'px';
      }
      el.style.top = (top + Math.max(0, (room - el.offsetHeight) / 2)) + 'px';
    }

    /* Al abrir el sobre, cada objeto de la mesa sale deslizándose por el borde más
       cercano y desaparece del todo (no se puede volver a ver ni arrastrar hasta
       recargar), para que toda la atención vaya al contenido del sobre. */
    clearDecor(instant = false){
      if (this.dataset.clear === 'false') return;
      const m = this.mat.getBoundingClientRect();
      const OUT = 0.6; // el centro queda a 60 % de su tamaño fuera del borde: totalmente fuera
      this.decor.forEach(el => {
        const b = el.getBoundingClientRect();
        const cx = b.left + b.width / 2 - m.left;
        const cy = b.top + b.height / 2 - m.top;
        const dist = { left: cx, right: m.width - cx, top: cy, bottom: m.height - cy };
        const side = Object.keys(dist).reduce((a, k) => dist[k] < dist[a] ? k : a);
        let x = cx, y = cy;
        if (side === 'left')   x = -b.width * OUT;
        if (side === 'right')  x = m.width + b.width * OUT;
        if (side === 'top')    y = -b.height * OUT;
        if (side === 'bottom') y = m.height + b.height * OUT;
        el.dataset.moved = '1';
        el.setAttribute('aria-hidden', 'true');
        el.tabIndex = -1;
        if (instant) el.classList.add('is-gone');
        else {
          el.classList.add('is-flying');
          this.timers.push(setTimeout(() => el.classList.replace('is-flying', 'is-gone'), FLY_MS + 50));
        }
        el.style.setProperty('--x', x / m.width * 100);
        el.style.setProperty('--y', y / m.height * 100);
      });
    }

    target(el){
      const d = el.dataset;
      return this.portrait ? [d.mx, d.my, d.mr] : [d.x, d.y, d.r];
    }

    place(el){
      const [x, y, r] = this.target(el);
      el.style.setProperty('--x', x);
      el.style.setProperty('--y', y);
      el.style.setProperty('--r', r);
    }

    open(instant = false){
      if (this.opened) return;
      this.opened = true;
      this.fitSoon();
      const s = this.sobre;
      s.setAttribute('aria-label', `${s.dataset.name}. Arrástralo o pulsa para ver qué es`);
      this.hint.classList.remove('is-pulsing');
      this.hint.classList.add('is-hidden');

      if (instant){
        this.clearDecor(true);
        s.classList.add('is-flipped', 'is-open');
        this.piezas.forEach(el => { el.classList.remove('is-stowed'); this.place(el); });
        this.showMesaCta();
        if (this.soon) this.soon.classList.add('is-visible');
        return;
      }

      this.clearDecor();
      s.classList.add('is-flipped');
      const later = (fn, ms) => this.timers.push(setTimeout(fn, ms));
      later(() => s.classList.add('is-open'), FLIP_MS);

      const start = FLIP_MS + OPEN_MS;
      if (this.soon) later(() => this.soon.classList.add('is-visible'), start);
      this.piezas.forEach((el, i) => later(() => {
        el.classList.add('is-flying');
        el.classList.remove('is-stowed');
        el.style.zIndex = ++this.zTop;
        this.place(el);
        later(() => el.classList.remove('is-flying'), FLY_MS + 50);
      }, start + i * STAGGER_MS));

      // El botón fijo aparece cuando ya han caído todas las piezas
      later(() => this.showMesaCta(), start + this.piezas.length * STAGGER_MS + FLY_MS);

      // con el aviso «Coming soon» no hay piezas que arrastrar: no se muestra el texto de ayuda
      const openText = !this.soon && this.hint.dataset.openText;
      if (openText){
        later(() => {
          this.hint.textContent = openText;
          this.hint.classList.remove('is-hidden');
          later(() => this.hint.classList.add('is-hidden'), 4500);
        }, start + this.piezas.length * STAGGER_MS + FLY_MS);
      }
    }

    /* Modo preventa: los botones con data-vm-preventa abren el diálogo del correo.
       Si la página viene de enviar el formulario (éxito o error), se abre solo. */
    preventa(){
      const dlg = this.querySelector('.vm-pre');
      if (!dlg) return;
      const openDlg = () => {
        this.hideInfo();
        if (dlg.open) return;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        const input = dlg.querySelector('.vm-pre__input');
        if (input && window.matchMedia('(hover: hover)').matches) input.focus();
      };
      const closeDlg = () => { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };

      this.querySelectorAll('[data-vm-preventa]').forEach(b => b.addEventListener('click', e => {
        e.preventDefault();
        openDlg();
      }));
      dlg.querySelector('.vm-pre__close').addEventListener('click', closeDlg);
      // clic fuera de la caja (en el fondo oscuro) = cerrar
      dlg.addEventListener('click', e => { if (e.target === dlg) closeDlg(); });

      const form = dlg.querySelector('form');
      if (form) form.addEventListener('submit', () => {
        const btn = form.querySelector('.vm-pre__submit');
        if (btn) btn.disabled = true;
      });
      // al volver atrás desde la verificación de Shopify, que el botón no se quede bloqueado
      window.addEventListener('pageshow', () => {
        const btn = form && form.querySelector('.vm-pre__submit');
        if (btn) btn.disabled = false;
      });

      const state = dlg.querySelector('.vm-pre__state');
      if (state && state.dataset.state !== 'idle') openDlg();
    }

    showMesaCta(){
      if (!this.mesaCta) return;
      this.mesaCta.classList.add('is-visible');
      this.mesaCta.removeAttribute('aria-hidden');
      this.mesaCta.removeAttribute('tabindex');
    }

    /* Clic en el sobre: cerrado → se abre. Abierto → un clic muestra su ficha;
       doble clic le da la vuelta (cara de delante ↔ cara de detrás). Para distinguirlos,
       el clic sencillo espera DOUBLE_TAP_MS antes de abrir la ficha. */
    tapSobre(){
      if (!this.opened){
        this.open();
        this.ignoreTapsUntil = Date.now() + FLIP_MS + OPEN_MS; // que el segundo clic del gesto no cuente
        return;
      }
      if (Date.now() < (this.ignoreTapsUntil || 0)) return;
      if (this.pendingTap){
        clearTimeout(this.pendingTap);
        this.pendingTap = null;
        this.hideInfo();
        this.sobre.classList.toggle('is-flipped');
        return;
      }
      this.pendingTap = setTimeout(() => {
        this.pendingTap = null;
        this.showInfo(this.sobre);
      }, DOUBLE_TAP_MS);
      this.timers.push(this.pendingTap);
    }

    /* Arrastrar. onTap se llama si se suelta sin haber movido (un clic).
       canDrag permite bloquear el arrastre (el sobre antes de abrirse). */
    draggable(el, onTap, canDrag = () => true){
      let start = null;

      el.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        const rect = this.mat.getBoundingClientRect();
        start = { px: e.clientX, py: e.clientY, x: getVar(el, '--x'), y: getVar(el, '--y'), w: rect.width, h: rect.height, moved: false };
        el.setPointerCapture(e.pointerId);
        if (canDrag()){
          el.style.zIndex = ++this.zTop;
          el.classList.add('is-held');
        }
      });

      el.addEventListener('pointermove', e => {
        if (!start) return;
        const dx = e.clientX - start.px, dy = e.clientY - start.py;
        if (!start.moved && Math.hypot(dx, dy) < 5) return;
        start.moved = true;
        if (!canDrag()) return;
        this.hideInfo();
        el.dataset.moved = '1';
        el.classList.remove('is-flying');
        el.style.setProperty('--x', clamp(start.x + dx / start.w * 100, Math.min(2, start.x), Math.max(98, start.x)));
        el.style.setProperty('--y', clamp(start.y + dy / start.h * 100, Math.min(2, start.y), Math.max(98, start.y)));
      });

      el.addEventListener('pointerup', () => {
        if (!start) return;
        el.classList.remove('is-held');
        if (!start.moved) onTap();
        start = null;
      });
      el.addEventListener('pointercancel', () => { el.classList.remove('is-held'); start = null; });

      // Teclado: flechas mueven (Mayús = más rápido), Enter/Espacio = clic
      el.addEventListener('keydown', e => {
        const step = e.shiftKey ? 5 : 1;
        const moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
        if (moves[e.key] && canDrag()){
          e.preventDefault();
          const [mx, my] = moves[e.key];
          el.style.zIndex = ++this.zTop;
          el.style.setProperty('--x', clamp(getVar(el, '--x') + mx, 2, 98));
          el.style.setProperty('--y', clamp(getVar(el, '--y') + my, 2, 98));
        } else if (e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          onTap();
        }
      });
      el.addEventListener('click', e => e.preventDefault()); // el clic se gestiona en pointerup
    }

    showInfo(el){
      const d = el.dataset;
      if (!d.name && !d.desc) return;
      this.info.querySelector('.vm-info__num').textContent = d.num || '';
      this.info.querySelector('.vm-info__name').textContent = d.name || '';
      this.info.querySelector('.vm-info__desc').textContent = d.desc || '';
      this.info.classList.add('is-open');
    }

    hideInfo(){ this.info.classList.remove('is-open'); }
  }

  customElements.define('vertigo-mesa', VertigoMesa);
})();

  } catch(e) { console.error(e); }
})();
})();
